import { Navigate } from "react-router-dom";
import { SignIn } from "@clerk/react";
import { useAuth } from "@/context/AuthContext";

export default function GoogleSignIn() {
  const { user } = useAuth();
  if (user) return <Navigate to="/entries" replace />;
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-6 bg-slate-50 p-4" data-testid="google-signin-page">
      <img src="/flower-logo.png" alt="" className="h-12 w-12" />
      <SignIn routing="path" path="/sign-in" signUpUrl="/sign-up" withSignUp />
      <a href="/login" className="text-sm text-slate-500 hover:text-slate-800" data-testid="back-to-password-login">
        Back to email &amp; password sign-in
      </a>
    </div>
  );
}
